export function getFileNameFromUrl(urlString) {
  try {
    // Attempt to parse as a URL
    const url = new URL(urlString);
    const pathname = url.pathname;
    const lastSegment = pathname.split('/').pop();

    // Check for presence of a dot (.) and at least one character after it
    if (lastSegment && /\.[a-zA-Z0-9]{1,10}$/.test(lastSegment)) {
      return lastSegment;
    }
  } catch (err) {
    // If parsing as URL fails, treat it as a URI
    const lastSegment = urlString.split('/').pop();

    if (lastSegment && /\.[a-zA-Z0-9]{1,10}$/.test(lastSegment)) {
      return lastSegment;
    }
  }

  return null; // Not a valid file name
}